TimeTableWithSearch = class {
    constructor(t) {
        this.target = t;
        this.routeElement = this.target.querySelector("[name=route]");
        this.fromText = this.target.querySelector("span[data-route-from-text]");
        this.toText = this.target.querySelector("span[data-route-to-text]");
        this.dateText = this.target.querySelector("span[data-date-text]");
        this.routeLargeSelect = this.target.querySelector("[data-select-type=list]");
        this.dateElement = this.target.querySelector("input[name=outboundDate]");
        this.routeSelect = {};

        this.init();
    }
    
    init() {        
        this.initRoutes();
        this.initEvents();
    }
    
    findById(array, id) {
        return array.find(item => item.Id === id);
    }

    initRoutes() {
        this.getDefaultRoute()
            .then(route => this.mapRoutes(route)
                .then(_ => this.loadCrossings(route)))
            .then(_ => {
                this.routeSelect = new LargeSelectList(this.routeLargeSelect);
            })
            .then(_ => this.routeElement.dispatchEvent(new Event("change")));
    }

    initEvents() {
        this.routeElement.addEventListener("change", (evt) => {
            this.fromText.innerHTML = evt.target.options[evt.target.selectedIndex].dataset.fromValue;
            this.toText.innerHTML = evt.target.options[evt.target.selectedIndex].dataset.toValue;
            
            this.loadCrossings();
        });
        
        this.dateElement.addEventListener("change", (evt) => {
            
            this.loadCrossings(evt);
        });
        
    }
    
    getRoutes(locations, selectedRoute) {
        return this.get("/api/data/routes")
            .then(routes => {
                return routes
                    .filter(route => this.findById(locations, route.DepartureId))
                    .filter(route => this.findById(locations, route.DestinationId))
                    .map(route => {
                        let value = `${route.DepartureId},${route.DestinationId}`;

                        return {
                            Departure: this.findById(locations, route.DepartureId),
                            Destination: this.findById(locations, route.DestinationId),
                            Value: value,
                            Selected: value === selectedRoute
                        };
                    });
            });
    }

    getDefaultRoute() {
        return this.get("/api/data/variables/B2CDefaultRoute");
    }

    getLocation(id) {
        return this.get(`/api/data/Location/${id}`);
    }

    getDepartureLocations() {
        return this.get("/api/data/DeparturePoints")
            .then(data => data.filter(location => location.DeparturePoint));
    }
    
    getCrossings(departureId, destinationId, year, month, day){
        return this.getHtml(`/api/data/TimetableCrossings/${year}/${month}/${day}/${departureId}/${destinationId}`);
    }

    loadCrossings(evt){
        const dateElement = this.dateElement.closest(".date-time-picker--date-only");
        const date = new Date(this.dateElement.value);
        if(moment(date).isSameOrAfter(moment(new Date()),"day")){
            if(evt !== undefined && evt.target !== undefined){
                
                this.dateText.innerHTML = new moment(evt.target.value).format("Do MMMM YYYY");
            }
            const routeElement = this.routeLargeSelect.closest(".large-select-list");
            dateElement.classList.add("disabled");
            routeElement.classList.add("disabled");

            const tableBody = this.target.querySelector("[data-timetable]");
            const loader = this.target.querySelector("#processingwait");

            tableBody.innerHTML = "";
            loader.style = "";

            const route = this.routeElement.value;

            const departure = route.split(',')[0];
            const destination = route.split(',').pop();

            if (departure && destination && date){
                const dateNumber = date.getDate();
                const month = date.getMonth() + 1;
                const year = date.getFullYear();
                return this.getCrossings(departure, destination, year, month, dateNumber)
                    .then(html => {
                        tableBody.innerHTML = html;
                        loader.style = "display:none;"
                        dateElement.classList.remove("disabled");
                        routeElement.classList.remove("disabled");
                    });
            }
        }
        
    }

    addRouteOption(route, cb, context = this) {
        let text = `${route.Departure.Name} to ${route.Destination.Name}`;
        let dataValue = `${route.Departure.Name} <span class='icon'>→</span> ${
            route.Destination.Name
        }`;

        let option = new Option(text, route.Value, route.Selected);

        if (route.Selected) {
            context.routeElement.value = route.Value;
        }

        option.dataset["textvalue"] = dataValue;
        
        option.dataset["fromValue"] = route.Departure.Name;
        option.dataset["toValue"] = route.Destination.Name;

        context.routeElement.appendChild(option);
        cb();
    }

    mapRoutes(selectedRoute) {
        return this.getDepartureLocations()
            .then(locations => this.getRoutes(locations, selectedRoute))
            .then(routes => routes.forEachAsync(this.addRouteOption, this)
                .then(_ => (this.routeElement.value = routes.find(x => x.Selected).Value))
            );
    }
    
    get(uri) {
        return window.fetch(uri)
            .then(response => response.json());
    }    
    
    getHtml(uri) {
        return window.fetch(uri)
            .then(response => response.text());
    }
};

document.addEventListener("DOMContentLoaded",
    function () {
        const container = document.querySelector("div[data-timetable-container]");
        
        if (container){
            new TimeTableWithSearch(container);
        }
    });